module.exports = __webpack_public_path__ + "img/comp-icon.a8fb954c.svg";